"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFavoriteSystemMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.toggleFavoriteSystemMutation = (0, graphql_tag_1.default) `
  mutation ToggleFavoriteSystem($systemId: String!) {
    toggleFavoriteSystem(systemId: $systemId)
  }
`;
//# sourceMappingURL=toggle-favorite-system.js.map